// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".users-restaurants-table-wrapper\r\n  table.MuiTable-root:first-child\r\n  tbody\r\n  tr\r\n  td:last-child\r\n  > div {\r\n  justify-content: center;\r\n}\r\n", ""]);
